export default "__VITE_ASSET__CrCkLRFW__"